import api from "./axios";

export const getUserDayTimes = async (userId) => {
    const res = await api.get(`/day_time_list/${userId}`);
    return Array.isArray(res.data?.times)
        ? res.data.times
        : [];
};

export const updateUserRole = async (roleId, userId) => {
    await api.put(`/branch-user-roles/${roleId}`, {
        user_id: userId,
    });
};
// PIE CHART
export const getUserPieChart = async (branchUserId) => {
    const res = await api.get(`/pie-chart/${branchUserId}`);
    return res.data;
};

// LINE CHART
export const getUserLineChart = async (branchUserId) => {
    const res = await api.get(`/line-chart/${branchUserId}`);
    return res.data;
};